// native
import {
  Component,
  HostListener,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  OnInit
} from "@angular/core";

// service
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: "scs-file-uploader",
  templateUrl: "./file-uploader.component.html"
})
export class FileUploaderComponent implements OnInit {

  @Input() allowedFileExtensions: string;
  @Input() maxSizeInKilobytes: number;
  @Input() uploadedFiles: any[];

  @Output() onFileUploaded: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('defaultFileUploader') fileUploader: ElementRef;

  isUploading: boolean = false;
  isUploaded: boolean = false;
  percentageDone: number = 0;

  allowedFileMimeTypes: string = '';

  isInvalidFileMessageShown: boolean = false;
  invalidFileFormatText: string = '';

  file: File;

  isExistingFileShown: boolean = false;

  constructor(
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.calculateAllowedMimeTypes(this.allowedFileExtensions);
    this.calculateInvalidFileMessage();
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event) {
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  onDrop(event) {
    event.preventDefault();
    const files = event.dataTransfer.files;
    this.onFileSelect(files);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event) {
    event.preventDefault();
  }

  onUploaderClick() {
    this.fileUploader.nativeElement.value = '';
    this.fileUploader.nativeElement.click();
  }

  onFileSelect(files: File[]) {
    const file = files[0];
    console.log("file", file)

    if (file && this.isFileValid(file)) {
      this.file = file;
      this.uploadFile(file);
      this.isInvalidFileMessageShown = false;
    } else if (file) {
      this.isInvalidFileMessageShown = true;
    }
  }

  //TODO check if toast is enough
  private isFileValid(file: File): boolean {
    if (file.size > this.maxSizeInKilobytes * 1100) {
      this.toastService.openToast({
        text: `Please upload a file no larger than ${this.maxSizeInKilobytes} KB.`,
        type: 'error'
      });
      return false;
    }

    if (!this.allowedFileMimeTypes.includes(file.type)) {
      this.toastService.openToast({
        text: `Please upload a file in one of the following formats: ${this.invalidFileFormatText}.`,
        type: 'error'
      });
      return false;
    }

    return true;
  }

  private calculateAllowedMimeTypes(allowedFileExtensions: string): void {
    const extension = allowedFileExtensions.split(',');

    extension.forEach(ext => {
      switch (ext) {
        case 'jpg':
        case 'jpeg':
          this.allowedFileMimeTypes = this.allowedFileMimeTypes.concat(',image/jpeg');
          break;
        case 'gif':
          this.allowedFileMimeTypes = this.allowedFileMimeTypes.concat(',image/gif');
          break;
        case 'png':
          this.allowedFileMimeTypes = this.allowedFileMimeTypes.concat(',image/png');
          break;
        case 'pdf':
          this.allowedFileMimeTypes = this.allowedFileMimeTypes.concat(',application/pdf');
          break;
        case 'xml':
          this.allowedFileMimeTypes = this.allowedFileMimeTypes.concat(',text/xml');
          this.allowedFileMimeTypes = this.allowedFileMimeTypes.concat(',application/xml');
          break;
        case 'csl':
          this.allowedFileMimeTypes = this.allowedFileMimeTypes.concat(',application/vnd.citationstyles.style+xml');
          break;
      }
    });
  }

  private calculateInvalidFileMessage(): void {
    this.invalidFileFormatText = this.allowedFileExtensions.split(',').join(', ');
  }

  private uploadFile(file: File) {
    this.isUploading = true;

    const formData = new FormData();
    formData.append('file', file);

    const fileReader = new FileReader();

    fileReader.onload = (function (event: any) {
      this.isUploading = false;
      this.onFileUploaded.emit(event.target.result);
    }).bind(this);

    fileReader.readAsText(this.file);
  }
}

